const state = {
    systemInfo: {}
}

const getters = {
    systemInfo: state => state.systemInfo,
}

const mutations = {
    setSystemInfo(state, systemInfo) {
        state.systemInfo = systemInfo;
    },
    
}

const actions = {
    setSystemInfo({ commit }, systemInfo) {
        commit("setSystemInfo", systemInfo);
    },
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
  



// WEBPACK FOOTER //
// ./src/store/modules/server/index.js